import { Component, OnInit } from '@angular/core';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';

@Component({
  selector: 'app-credential-list',
  templateUrl: './credential-list.component.html',
  styleUrls: ['./credential-list.component.css']
})
export class CredentialListComponent implements OnInit {
  companies:any;
  search: any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS

  constructor(private credentialService :  CredentialService){}

  ngOnInit(): void {
    this.getCredentialCompanies(this.currentPage);
  }


  getCredentialCompanies(page:number){
    const queryparams = {
      limit: 50,
      page
    }
    this.credentialService.getCompanies(queryparams)
      .subscribe((data: any) => {
        if (data && data.results ) {
          this.companies = data.results
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getCredentialCompanies(page);
  }
}
